// extracted by mini-css-extract-plugin
module.exports = {"container":"TutorialsIcon_container__9DMCQ","group":"TutorialsIcon_group__tsoal"};